import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../Button";

const DownloadTemplateCard = ({
  description,
  onClick,
  loading,
  disabled,
  buttonTitle = "common.downloadTemplate",
}) => {
  const { t } = useTranslation();
  return (
    <div className="border border-blue-300 bg-blue-100 rounded-lg p-4">
      <div>
        <p className="text-sm text-blue-600 mb-3">{t(description)}</p>
        <Button
          form="upload-form"
          className="w-full"
          type="button"
          variant="secondary"
          loading={loading}
          disabled={disabled}
          onClick={onClick}
        >
          {t(buttonTitle)}
        </Button>
      </div>
    </div>
  );
};

export default DownloadTemplateCard;
